import { Menu } from 'react-admin';
import { useAccessContext } from '../auth/useAccessContext';
import { visibleNavItems } from './nav';

/**
 * Sidebar menu that only shows items the current role/region is permitted to
 * see (items are hidden, not shown-then-blocked). Uses the same access decision
 * as the route guard via `visibleNavItems`.
 */
export const AppMenu = () => {
  const { role, accessibleRegions } = useAccessContext();
  const items = visibleNavItems({ role, accessibleRegions });

  return (
    <Menu>
      <Menu.DashboardItem />
      {items.map((item) => (
        <Menu.Item key={item.to} to={item.to} primaryText={item.label} />
      ))}
    </Menu>
  );
};
